import requestor from "requestor";

import BaseRoute from "utils/base_route";
import getRouteIds from "utils/get_route_ids";

import DocumentReportContainer from "./containers/document_report";

import documentFetchAction from "modules/documents/actions/document_fetch";
import documentsFetchAction from "modules/documents/actions/documents_fetch";
import documentTopicsFetchAction from "modules/documents/actions/document_topics_fetch";
import topicCategoriesFetchAction from "modules/documents/actions/topic_categories_fetch";
import topicTagsFetchAction from "modules/documents/actions/topic_tags_fetch";
import contractTypesFetchAction from "modules/documents/actions/contract_types_fetch";
import documentStateFetchAction from "modules/documents/actions/document_state/fetch";
import definitionGroupsFetchAction from "modules/documents/actions/definition_group/definition_groups_fetch";

import documentClearAction from "modules/documents/actions/document_clear";
import topicsClearAction from "modules/documents/actions/topics_clear";
import topicCategoriesClearAction from "modules/documents/actions/topic_categories_clear";
import topicTagsClearAction from "modules/documents/actions/topic_tags_clear";
import contractTypesClearAction from "modules/documents/actions/contract_types_clear";
import searchClearAction from "modules/search/actions/search_clear";
import documentStateClearAction from "modules/documents/actions/document_state/clear";
import logsClearAction from "modules/logs/actions/logs_clear";
import definitionGroupsClearAction from "modules/documents/actions/definition_group/definition_groups_clear";

export default class DocumentReport extends BaseRoute {
  constructor(store) {
    super(":documentId/report", store);
  }

  getComponents(location, cb) {
    cb(null, DocumentReportContainer);
  }

  fetchActiveData(props) {
    this.fetchDocuments(props);
    this.fetchDocumentClauses(props);
    this.fetchTopics(props);
    this.fetchTopicCategories(props);
    this.fetchTopicTags(props);
    this.fetchContractTypes(props);
    this.fetchDocumentStates(props);
    this.fetchDefinitionGroups(props);
  }

  fetchDocuments(props) {
    const {organisationId, projectId} = getRouteIds(props.router);
    this.store.dispatch(
      documentsFetchAction(requestor)(organisationId, projectId),
    );
  }

  fetchDocumentClauses(props) {
    const {organisationId, projectId, documentId} = getRouteIds(props.router);
    if (documentId) {
      this.store.dispatch(
        documentFetchAction(requestor)(organisationId, projectId, documentId),
      );
    }
  }

  fetchTopics(props) {
    const {organisationId, projectId, documentId} = getRouteIds(props.router);
    this.store.dispatch(
      documentTopicsFetchAction(requestor)(
        organisationId,
        projectId,
        documentId,
      ),
    );
  }

  fetchTopicCategories(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(topicCategoriesFetchAction(requestor)(organisationId));
  }

  fetchTopicTags(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(topicTagsFetchAction(requestor)(organisationId));
  }

  fetchContractTypes(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(contractTypesFetchAction(requestor)(organisationId));
  }

  fetchDocumentStates(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(documentStateFetchAction(organisationId));
  }

  fetchDefinitionGroups(props) {
    const {organisationId} = getRouteIds(props.router);
    this.store.dispatch(definitionGroupsFetchAction(requestor)(organisationId));
  }

  clearActiveData(props) {
    const {organisationId, projectId, documentId} = getRouteIds(props.router);
    this.store.dispatch(
      documentClearAction(organisationId, projectId, documentId),
    );
    this.store.dispatch(topicsClearAction(organisationId));
    this.store.dispatch(topicCategoriesClearAction(organisationId));
    this.store.dispatch(topicTagsClearAction(organisationId));
    this.store.dispatch(contractTypesClearAction());
    this.store.dispatch(searchClearAction());
    this.store.dispatch(documentStateClearAction());
    this.store.dispatch(logsClearAction());
    this.store.dispatch(definitionGroupsClearAction());
  }
}
